module.exports = "/_next/static/images/93b8279087f78ecd55428684efd86ebd-xpeer-fgts@1x.jpg.webp";